import * as React from 'react';
import { Evento } from './Evento';
import { makeStyles } from '@material-ui/core/styles'
import Pagination from "@material-ui/lab/Pagination";
import { Typography } from '@material-ui/core';
import { api, HomeWidgetError, HomeWidgetVacio, PortalContext, Link, useMsal, getCiaFromUrl } from '@portal/arq-portal-core';
import useSWR from 'swr';
import { updateUrlParameter } from '../utils/enlace';

const useStyles = makeStyles((theme) => ({
    widget: {
        width: 'auto',
        height: 'auto',
        '& .widget-header': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid #919191',
            height: "48px",
            '& h6': {
                color: "#606060",
                fontFamily: "CO-Bold",
                fontSize: "16px",
            },
            
            '& .heading': {
                fontSize: '14px',
                fontFamily: theme.typography.h2.fontFamily,
                margin: '0',
                color: theme.palette.primary.main,
            },
            '& .vermas': {
                fontSize: '12px',
                fontWeight: 'bold',
                borderBottom: `1px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                '&:hover': {
                    color: '#b7788f',
                    borderBottom: '1px solid #b7788f',
                },
            }
        },
        '& .widget-content': {

            '& .event-list': {
                padding: '0',
                listStyleType: 'none',
                height: '180px',
                marginBlockStart: '10px',
                marginBlockEnd: '10px',

                '@media screen and (max-width: 959px)': {
                    height: 'auto',
                }
            }
        },
    },
    paginator: {
        borderTop: '1px solid #d6d8d8',
        paddingTop: '.5rem',
        justifyContent: "center"
    }
}))

function ciaMatchSharePointName(cia: string ){
    switch(cia){
        case 'SBI': 
            return 'SB';
        case 'SPU':
            return 'PU';
    }
    return cia;
}

export function Eventos(props: any): JSX.Element {
    const classes = useStyles();
    let { datos, error, verMas } = props
    const itemsPerPage = 3;
    const [page, setPage] = React.useState(1);

    const { user, mostrarEventos } = React.useContext(PortalContext);
    const msal = useMsal();
    const  cia =  ciaMatchSharePointName(getCiaFromUrl());
    if (!datos && !error) {
        const response = useSWR(mostrarEventos?["eventos", user?.id]:null, () => msal.getTokenSilent().then((token:string)=>api.post("/cache/eventos/", { Entrada: { AccessToken: token } })),{dedupingInterval: 60000});
        datos = response.data?.Salida.Resultados;
        verMas = response.data?.Salida.VerMas;
        error = response.error;
    }

    const noOfPages =
        datos ? Math.ceil(datos.length / itemsPerPage) : 0;

    // @ts-ignore
    const handleChange = (event: any, value: any) => {
        setPage(value);
    };

    return (
        <React.Fragment>
            { !mostrarEventos? null :
                <React.Fragment>
                    <div className={classes.widget}>
                        <div className="widget-header">
                            <Typography variant="h6">{props.titulo ?? "Eventos"}</Typography>
                            <Link className="vermas" to={ updateUrlParameter(verMas,"cia",cia)} title="Ver más">Ver más</Link>
                        </div>
                        {datos && datos.length > 0 && <div className="widget-content">
                            <ul className={`event-list ${datos ? `total-events-${datos?.length}` : null}`}>
                                {
                                    datos?.slice((page - 1) * itemsPerPage, page * itemsPerPage)
                                        .map((el: any, index: any) => {
                                            return (
                                                <Evento key={index} event={el} events={datos.length} />
                                            )
                                        })
                                }
                            </ul>
                            {noOfPages > 1 && <Pagination
                                classes={{ ul: classes.paginator }}
                                count={noOfPages}
                                page={page}
                                onChange={handleChange}
                                defaultPage={1}
                                shape="rounded"
                                size="small"
                            />}
                        </div>}
                        {!error && (!datos || datos.length == 0 )&& <div className="widget-content"><HomeWidgetVacio mensaje="No hay eventos próximamente"></HomeWidgetVacio></div>}
                        {error && error.message && !datos && <div className="widget-content"><HomeWidgetError error={error.message}></HomeWidgetError></div>}
                        {error && !error.message && !datos && <div className="widget-content"><HomeWidgetError error="Datos no disponibles en estos momentos"></HomeWidgetError></div>}
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    )
}